import * as tslib_1 from "tslib";
import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import UEditor from "@/components/UEditor/index.vue";
import VRadio from "./VRadio.vue";
import VCheckBox from "./VCheckBox.vue";
import VOption from "./VOption.vue";
import { QUESTION_TYPE_MAP } from "../constant";
import { getQuestionDetail, saveQuestionDetail } from "@/api/question";
let QuestionForm = class QuestionForm extends Vue {
    constructor() {
        super(...arguments);
        this.isSafari = false;
        this.showTitlePlaceHolder = true;
        this.fillInAnswerArr = [''];
        this.updataFillInData = [];
        this.disorderMatch = false;
        this.ueDefaultMsg = '';
        this.checkStatus = [];
        this.optionList = [];
        this.deleteList = [];
        this.addList = [];
        this.questionContent = '';
        this.questionDescribe = '';
        this.analysisContent = '';
        this.questionTitleInitContent = 4 == this.type ? '<span style="color:#B2B2B2">题目示例：鹅鹅（），曲（）向天歌</span>' : '<span style="color:#B2B2B2">请输入内容</span>';
        this.questionContentDefault = '';
        this.analysisContentDefault = '';
        this.answerContentDefault = '';
        this.answerContent = '';
        this.newOptionList = [];
        this.oldOptionList = [];
        this.delOptionList = [];
        this.titleInstance = null;
        this.analysisInstance = null;
        this.answerInstance = null;
        this.isClicked = false;
        this.nativeInfo = '';
        this.handleSaveFlag = true;
        this.cancalForbid = false;
        this.iterator = 0;
        this.target = '';
        this.judgeTrue = true;
        this.judgeFalse = false;
        this.showDialog = false;
        this.topicTypeName = '';
        this.parentID = '';
        this.errmsg = '';
        this.uEditorConfig = {
            title: {},
            answer: {},
            analysis: {}
        };
        this.disabledStateWatcher = null;
        this.paperId = '';
        this.delDisabled = false;
    }
    get randomKey() {
        return (new Date).getTime();
    }
    get tempOptionList() {
        return this.isEdit ? [...this.oldOptionList, ...this.newOptionList] : this.optionList;
    }
    get showDelete() {
        switch (this.type) {
            case 0:
                return this.tempOptionList.length > 2;
            case 1:
                return this.tempOptionList.length > 3;
            case 5:
                return this.tempOptionList.length > 2;
            default:
                return false;
        }
    }
    get mapType() {
        const type = QUESTION_TYPE_MAP.find(t => t.id === this.type);
        return type && type.text || "";
    }
    get hasSetCorrectAnswer() {
        const count = this.checkStatus.filter((state) => state === true).length;
        if (this.type === 0) {
            return !!count;
        }
        else if (this.type === 1) {
            return count >= 2;
        }
        else if (this.type === 5) {
            return count >= 1;
        }
    }
    get hasData() {
        return this.data ? Object.keys(this.data).length > 0 : false;
    }
    get isReference() {
        return this.disabled || this.delDisabled;
    }
    created() {
        window.UEDITOR_CONFIG.initialFrameWidth = 680;
        var t = navigator.userAgent;
        this.isSafari = /Safari/.test(t) && !/Chrome/.test(t);
        Object.keys(this.uEditorConfig).forEach((key) => {
            this.uEditorConfig[key].id = `${key}-${this.getRandomHash()}`;
        });
        this.paperId = this.$route.query.paperId || "";
        this.$nextTick(() => {
            this.$bus.$on("get-check-radio", (t) => {
                for (var n = 0; n < this.checkStatus.length; n++)
                    this.$set(this.checkStatus, n, n === t);
                if (t === 0) {
                    this.judgeTrue = true;
                    this.judgeFalse = false;
                }
                else {
                    this.judgeTrue = false;
                    this.judgeFalse = true;
                }
                this.$bus.$emit("reset-radio-status", t);
            });
            this.$bus.$on("get-check-box", (t, n) => {
                for (var r = 0; r < this.checkStatus.length; r++)
                    if (t === r) {
                        this.$set(this.checkStatus, r, n);
                        break;
                    }
            });
            this.$bus.$on("get-option-content", (index, data) => {
                let target;
                if (this.isEdit) {
                    if (this.oldOptionList.length > index) {
                        target = this.oldOptionList[index];
                    }
                    else {
                        target = this.newOptionList[index - this.oldOptionList.length];
                    }
                }
                else {
                    target = this.optionList[index];
                }
                if (target) {
                    // target.id = data.id
                    target.content = data.content;
                    target.describ = data.describ;
                }
            });
        });
    }
    destroyed() {
        this.$bus.$off("get-check-radio");
        this.$bus.$off("get-check-box");
        this.$bus.$off("get-option-content");
        // this.$bus.$off("playNextAudio")
        console.log("destroy done");
    }
    mounted() {
        this.isEdit && (this.showTitlePlaceHolder = false);
        setTimeout(() => {
            this.titleInstance = this.title;
            this.analysisInstance = this.analysis;
            this.answerInstance = this.answer;
            this.init();
        }, 30);
    }
    getRandomHash() {
        return `${Math.random().toString(16).slice(2)}${Date.now()}`;
    }
    async init() {
        if (this.isEdit) {
            if (this.hasData) {
                return this.setFormData(this.data, this.data.optionList);
            }
            this.$bus.$emit("is_show_loading", true);
            try {
                const res = await getQuestionDetail(this.questionId);
                const data = res.data.data;
                this.$emit("get-question-reference", {
                    isReference: data.referenceCount > 0
                });
                this.delDisabled = data.referenceCount > 0;
                let answer, _optionList;
                if (this.type === 0 || this.type === 1 || this.type === 5) {
                    _optionList = data.optionList.map(opt => ({
                        id: opt.id,
                        content: opt.content,
                        describ: opt.simpleContent,
                        type: opt.correct
                    }));
                }
                else if (this.type === 2) {
                    answer = data.optionList[0].content;
                }
                else if (this.type === 3) {
                    answer = data.optionList[0].correct;
                }
                if (this.type === 4) {
                    answer = data.optionList.map(opt => opt.content);
                }
                this.setFormData({
                    id: data.id,
                    content: data.content,
                    analysis: data.analysis,
                    describ: data.simpleContent,
                    answer,
                    disorderMatch: data.disorderMatch
                }, _optionList);
            }
            catch (_) { }
            finally {
                this.$bus.$emit("is_show_loading", false);
                this.saveInitMessage();
            }
        }
        else {
            if (this.hasData) {
                const data = this.data;
                const optionList = data.optionList || [];
                optionList.forEach((option, n) => {
                    this.optionList.push(option);
                    this.checkStatus.push(option.type === 1);
                });
                const _data = {
                    id: this.questionId,
                    analysis: data.analysis,
                    content: data.content,
                    describ: data.describ,
                    answer: data.answer,
                    disorderMatch: data.disorderMatch || this.disorderMatch
                };
                setTimeout(() => {
                    this.setFormData(_data);
                }, 0);
            }
            else {
                for (var i = 0; i < 4; i++) {
                    this.optionList.push({
                        type: 1,
                        content: '',
                        describ: '',
                        id: Math.random().toString(16).slice(2)
                    });
                    this.checkStatus.push(false);
                }
            }
            this.saveInitMessage();
        }
    }
    processFillInData() {
        return this.fillInAnswerArr.slice(0).map((ans) => ans.split(/[;；]/).map(a => a.trim()).filter(a => a));
    }
    fillInFinalyData() {
        this.updataFillInData = this.processFillInData();
    }
    getUEContent(content, _, describ) {
        this.questionContent = content;
        this.questionDescribe = describ;
        this.$emit("question-content", content, describ);
    }
    getUEAnalysis(content) {
        this.analysisContent = content;
    }
    getUEAnswer(content) {
        this.answerContent = content;
    }
    deleteOption(index, optionId) {
        if (this.isEdit) {
            const oldListIndex = this.oldOptionList.findIndex(opt => opt.id === optionId);
            const newListIndex = this.newOptionList.findIndex(opt => opt.id === optionId);
            if (oldListIndex > -1) {
                this.delOptionList.push(this.oldOptionList[oldListIndex]);
                this.oldOptionList.splice(oldListIndex, 1);
            }
            else if (newListIndex > -1) {
                this.delOptionList.push(this.newOptionList[newListIndex]);
                this.newOptionList.splice(newListIndex, 1);
            }
        }
        else {
            this.optionList.splice(index, 1);
        }
        this.checkStatus.splice(index, 1);
        this.$forceUpdate();
    }
    validForm() {
        return this.checkPageInfo() && (!this.isClicked || !this.isEdit);
    }
    getParams() {
        const params = {
            type: this.type,
            categoryId: this.questionBankId,
            content: this.questionContent,
            // simpleContent: this.questionDescribe,
            analysis: this.analysisContent,
        };
        if (2 === this.type) {
            return {
                ...params,
                optionList: [{
                        content: this.answerContent
                    }]
            };
        }
        if (3 === this.type) {
            return {
                ...params,
                optionList: [{
                        correct: this.judgeTrue ? 1 : 0
                    }]
            };
        }
        if (4 === this.type) {
            return {
                ...params,
                optionList: this.fillInAnswerArr.map(ans => ({
                    content: ans
                })),
                disorderMatch: this.disorderMatch ? 1 : 0
            };
        }
        // 0 1 5
        if (!this.isEdit) {
            return {
                ...params,
                optionList: this.optionList.map((opt, index) => ({
                    content: opt.content,
                    correct: this.checkStatus[index] ? 1 : 0
                }))
            };
        }
        const oldOptionList = this.oldOptionList.map((opt, index) => ({
            content: opt.content,
            correct: this.checkStatus[index] ? 1 : 0
        }));
        const newOptionList = this.newOptionList.map((opt, index) => ({
            content: opt.content,
            correct: this.checkStatus[oldOptionList.length + index] ? 1 : 0
        }));
        return {
            ...params,
            optionList: [
                ...oldOptionList,
                ...newOptionList
            ]
        };
    }
    async save() {
        const isFormValid = this.validForm();
        if (isFormValid && this.handleSaveFlag) {
            // if (this.type === 4) {
            //   this.fillInFinalyData()
            // }
            this.isClicked = true;
            this.cancalForbid = true;
            const params = JSON.parse(JSON.stringify(this.getParams()));
            if (this.isEdit) {
                params.id = this.questionId;
            }
            this.handleSaveFlag = false;
            this.$bus.$emit("is_show_loading", true);
            try {
                await saveQuestionDetail(params);
                this.$message.success('保存成功');
                this.saveInitMessage();
                if (this.paperId || this.$route.query.step) {
                    this.handleSaveFlag = true;
                    this.$bus.$emit("edit-question-of-paper-success", this.questionId);
                }
                else {
                    setTimeout(() => {
                        this.handleSaveFlag = true;
                        this.$router.push({
                            name: "Question",
                            params: {
                                lib_id: params.categoryId || ''
                            }
                        });
                    }, 800);
                }
            }
            catch (error) {
                this.handleSaveFlag = true;
                this.cancalForbid = false;
                this.isClicked = false;
            }
            finally {
                this.$bus.$emit("is_show_loading", false);
            }
        }
    }
    addOption() {
        if (this.disabled)
            return;
        if (this.type === 4) {
            this.addBtn.focus();
            if (this.fillInAnswerArr.length >= 10) {
                this.$message.error('选项数量超过限制，暂不可添加');
            }
            else {
                this.fillInAnswerArr.push('');
            }
        }
        else {
            if (this.tempOptionList.length >= 26) {
                this.$message.error('选项数量超过限制，暂不可添加');
            }
            else {
                if (this.isEdit) {
                    this.newOptionList.push({
                        type: 1,
                        content: "",
                        describ: "",
                        id: Math.random().toString(16).substr(2)
                    });
                }
                else {
                    this.optionList.push({
                        type: 1,
                        content: "",
                        describ: "",
                        id: Math.random().toString(16).substr(2)
                    });
                }
                this.checkStatus.push(false);
            }
        }
    }
    handleInputEvent(evt, index) {
        this.fillInAnswerArr[index] = evt.target.innerText;
        if (evt.target.innerHTML === '<br>') {
            evt.target.innerHTML = '';
        }
    }
    deleteBlank(index) {
        this.addBtn.focus();
        this.fillInAnswerArr.splice(index, 1);
    }
    chaosAnswer() {
        if (this.disabled)
            return;
        this.disorderMatch = !this.disorderMatch;
    }
    cancel() {
        if (this.cancalForbid)
            return;
        this.$router.go(-1);
    }
    checkPageInfo() {
        if (this.questionBankId === '') {
            this.$message.warning("请选择题库分类");
            return false;
        }
        if (!this.questionContent) {
            this.errmsg = "您还未填写题目信息";
            this.$message.warning(this.errmsg);
            return false;
        }
        if (0 === this.type || 1 === this.type || 5 === this.type) {
            const unvalidOptionIndex = this.tempOptionList.findIndex(opt => !opt.content);
            if (unvalidOptionIndex > -1) {
                this.errmsg = `您还未填写${String.fromCharCode(65 + unvalidOptionIndex)}选项信息`;
                this.$message.warning(this.errmsg);
                return false;
            }
            if (!this.hasSetCorrectAnswer) {
                if (this.type === 0) {
                    this.errmsg = "您还未设置正确答案";
                }
                else if (this.type === 1) {
                    this.errmsg = "您至少需要设置2个正确答案";
                }
                else if (this.type === 5) {
                    this.errmsg = "您至少需要设置1个正确答案";
                }
                this.$message.warning(this.errmsg);
                return false;
            }
        }
        else if (2 === this.type) {
            // if (this.$refs.audioDom && this.$refs.audioDom.showProgress)
            //   return this.errmsg = "图片和音频上传完成后，才能提交哦！",
            //     this.$message.warning(this.errmsg),
            //     false;
            if (!this.answerContent) {
                this.errmsg = "您还未填写答案信息";
                this.$message.warning(this.errmsg);
                return false;
            }
        }
        else if (3 === this.type) {
            if (!this.judgeTrue && !this.judgeFalse) {
                this.errmsg = "您还未设置正确答案";
                this.$message.warning(this.errmsg);
                return false;
            }
        }
        else if (4 === this.type) {
            const fillinAnswer = this.processFillInData();
            const uncompletedIndex = fillinAnswer.findIndex(ans => {
                return ans.length === 0;
            });
            const unvalidIndex = fillinAnswer.findIndex(ans => ans.some(a => a.length > 10000));
            if (-1 !== uncompletedIndex) {
                this.errmsg = `请填写第${uncompletedIndex + 1}空答案`;
                this.$message.warning(this.errmsg);
                return false;
            }
            if (-1 !== unvalidIndex) {
                this.errmsg = `您的第${unvalidIndex + 1}项，有答案超过10000个字符`;
                this.$message.warning(this.errmsg);
                return false;
            }
        }
        return true;
    }
    saveInitMessage() {
        let _info = this.questionContent;
        if (this.type === 2) {
            _info += this.answerContent;
        }
        else {
            this.tempOptionList.forEach(opt => {
                _info += opt.type + opt.content;
            });
        }
        _info += this.analysisContent;
        this.nativeInfo = _info;
    }
    initEditor(type, content) {
        setTimeout(() => {
            let editorEl;
            if (type === 'title') {
                editorEl = this.title;
            }
            else if (type === 'answer') {
                editorEl = this.answer;
            }
            else if (type === 'analysis') {
                editorEl = this.analysis;
            }
            editorEl && editorEl.ue && editorEl.setContent(content);
        }, 300);
    }
    setFormData(data, optionList) {
        switch (this.type) {
            case 0:
            case 5:
            case 1:
                if (this.isEdit) {
                    this.oldOptionList = optionList;
                    this.newOptionList = data.newOptionList || [];
                    this.delOptionList = data.delOptionList || [];
                    this.oldOptionList.forEach(opt => {
                        this.checkStatus.push(opt.type === 1);
                    });
                    this.newOptionList.forEach(opt => {
                        this.checkStatus.push(opt.type === 1);
                    });
                }
                this.questionContent = data.content;
                this.questionDescribe = data.content;
                this.analysisContent = data.analysis;
                this.questionContentDefault = data.content;
                this.analysisContentDefault = data.analysis;
                break;
            case 2:
                this.questionContent = data.content;
                this.analysisContent = data.analysis;
                this.answerContent = data.answer;
                // this.initAudioUrls = data.audio_urls || [],
                this.questionContentDefault = data.content;
                this.analysisContentDefault = data.analysis;
                this.answerContentDefault = data.answer;
                break;
            case 3:
                this.questionContent = data.content;
                this.analysisContent = data.analysis;
                this.questionContentDefault = data.content;
                this.analysisContentDefault = data.analysis;
                this.judgeTrue = data.answer === 1;
                this.judgeFalse = data.answer === 0;
                break;
            case 4:
                this.questionContent = data.content;
                this.analysisContent = data.analysis;
                this.fillInAnswerArr = data.answer;
                this.disorderMatch = 1 == data.disorderMatch;
                this.questionContentDefault = data.content;
                this.analysisContentDefault = data.analysis;
                this.showTitlePlaceHolder = false;
                // this.fillInDataToString();
                break;
            default:
                break;
        }
        this.initEditor('title', this.questionContentDefault);
        this.initEditor('analysis', this.analysisContentDefault);
        this.initEditor('answer', this.answerContent);
    }
};
tslib_1.__decorate([
    Prop({ type: Boolean, default: false })
], QuestionForm.prototype, "isEdit", void 0);
tslib_1.__decorate([
    Prop({ type: [Number, String], default: 0 })
], QuestionForm.prototype, "type", void 0);
tslib_1.__decorate([
    Prop({ type: String, default: '' })
], QuestionForm.prototype, "questionId", void 0);
tslib_1.__decorate([
    Prop({ type: String, default: '' })
], QuestionForm.prototype, "questionBankId", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: true })
], QuestionForm.prototype, "isShowErrMsg", void 0);
tslib_1.__decorate([
    Prop({ type: Object, default: () => { } })
], QuestionForm.prototype, "data", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: false })
], QuestionForm.prototype, "disabled", void 0);
tslib_1.__decorate([
    Ref()
], QuestionForm.prototype, "title", void 0);
tslib_1.__decorate([
    Ref()
], QuestionForm.prototype, "answer", void 0);
tslib_1.__decorate([
    Ref()
], QuestionForm.prototype, "analysis", void 0);
tslib_1.__decorate([
    Ref()
], QuestionForm.prototype, "addBtn", void 0);
QuestionForm = tslib_1.__decorate([
    Component({
        name: 'QuestionForm',
        components: {
            Editor: UEditor,
            VRadio,
            VCheckBox,
            VOption
        },
    })
], QuestionForm);
export default QuestionForm;
